import React from 'react';
import Flex from '@Components/Bases/Flex';
import PDFButton from './PDFButton';

const handleDownload = (pdfUrl: string, pdfName: string) => {
  const link = document.createElement('a');
  link.href = pdfUrl;
  link.download = pdfName;
  link.click();
};

const convertBase64ToBlob = (base64: string) => {
  const byteCharacters = atob(base64.split(',')[1]);
  const byteNumbers = new Array(byteCharacters.length)
    .fill(0)
    .map((_, i) => byteCharacters.charCodeAt(i));
  const byteArray = new Uint8Array(byteNumbers);
  return new Blob([byteArray], { type: 'application/pdf' });
};

interface IPDFContainerProps {
  handleChipClick: (language: 'th' | 'en') => void;
  activeLanguage: 'th' | 'en';
  pdfData: string;
  pdfName: string;
}

const PDFContainer: React.FC<IPDFContainerProps> = ({
  handleChipClick,
  activeLanguage,
  pdfData,
  pdfName,
}) => {
  const base64Prefix = 'data:application/pdf;base64,';
  const completeBase64 = pdfData.startsWith(base64Prefix)
    ? pdfData
    : base64Prefix + pdfData;
  const blob = convertBase64ToBlob(completeBase64);
  const pdfUrl = URL.createObjectURL(blob);

  return (
    <Flex
      flexDirection="column"
      p={2}
      borderRadius={2}
      gap={1}
      mb={2}
      bgcolor="white"
      height="100%"
    >
      <PDFButton
        handleChipClick={handleChipClick}
        activeLanguage={activeLanguage}
        handleDownload={() => pdfData && handleDownload(pdfUrl, pdfName)}
      />
      <object
        data={pdfUrl}
        type="application/pdf"
        width="100%"
        height="100%"
        style={{ marginTop: '8px' }}
        aria-label="PDF Viewer"
      />
    </Flex>
  );
};

export default PDFContainer;
